"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationFilterTranslation = exports.notificationListFilterTranslations = exports.notificationDetailTranslations = exports.notificationsListTranslations = exports.notificationCenterTranslations = void 0;
exports.notificationCenterTranslations = {
    title: 'notification_center-page-title',
    settingsButton: 'notification_center-settings_button',
};
exports.notificationsListTranslations = {
    title: 'notification_center-list-title',
    loadError: 'notification_center-list-load_error',
    paginationRowsPerPage: 'pagination-rows_per_page',
    emptyResults: 'notification_center-list-empty_results',
    emptyResultsDescription: 'notification_center-list-empty_results_description',
    emptyFilterResults: 'notification_center-list-empty_filter_results',
    emptyFilterResultsDescription: 'notification_center-list-empty_filter_results_description',
};
exports.notificationDetailTranslations = {
    loadError: 'notification_center-details-load_error',
    empty: 'notification_center-detail-empty',
    emptyDescription: 'notification_center-detail-empty_description',
};
exports.notificationListFilterTranslations = {
    filtersPrefix: 'notification_center-list_filters-',
    filterButton: 'notification_center-list_filters-more_filters_button',
    resetButton: 'notification_center-list_filters-reset_filters_button',
    applyButton: 'notification_center-list_filters-apply_filters_button',
    title: 'notification_center-list_filters-title',
    durationTitle: 'notification_center-list_filters-duration_title',
    statusTitle: 'notification_center-list_filters-status_title',
    typeTitle: 'notification_center-list_filters-type_title',
};
const getNotificationFilterTranslation = (term) => {
    return `${exports.notificationListFilterTranslations.filtersPrefix}${term}`;
};
exports.getNotificationFilterTranslation = getNotificationFilterTranslation;
//# sourceMappingURL=translations.js.map